import { initReactI18next } from 'react-i18next';
import i18n from 'i18next';
import Backend from 'i18next-http-backend';

if (typeof window !== 'undefined') {
  window.localStorage.setItem('lng', 'en');
}

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'he', 'ru'],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    debug: false,
    preload: ['en'],
    backend: {
      loadPath: '/locales/{{lng}}/translation.json',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
